// React imports.
import React from "react";


// App imports.
import Assessment3DataReceivedTableRow from "./Assessment3DataReceivedTableRow";

const Assessment3DataReceivedTable = ({ state }) => (
    <div>
        
        <br />
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel	</div>
		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholds === true &&		
            <div className="header">Total # of Assisted Households</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showNumHouseholdsDataReceived1 === true &&		
            <div className="header"># of Households for Whom Main Heating Data was Received	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showpercentHouseholdsDataReceived === true &&		
            <div className="header">% of Households for Whom Main Heating Data was Received	</div>
            }		
            {state.Assessment3Steps[state.CurrentAssessementStepIndex].showDataReceivedStatus === true &&		
            <div className="header">Status</div>
            }		

            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Electric.name)
                &&
                <Assessment3DataReceivedTableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Electric.name )} state={state} fuel={state.Assessment3FuelTypesStatus.Electric} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.NaturalGas.name)
                &&
                <Assessment3DataReceivedTableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.NaturalGas.name )} state={state} fuel={state.Assessment3FuelTypesStatus.NaturalGas} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.FuelOil.name)
                &&
                <Assessment3DataReceivedTableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.FuelOil.name )} state={state} fuel={state.Assessment3FuelTypesStatus.FuelOil} />
            }
            {(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels === true
                || state.Assessment3Steps[state.CurrentAssessementStepIndex].currentFuelName === state.Assessment3FuelTypesStatus.Propane.name)
                &&
                <Assessment3DataReceivedTableRow rowClass={state.getGridRowClass(state.Assessment3Steps[state.CurrentAssessementStepIndex].showAllFuels, state.Assessment3FuelTypesStatus.Propane.name )} state={state} fuel={state.Assessment3FuelTypesStatus.Propane} />
            }
        </div>
    </div>
);

export default Assessment3DataReceivedTable;
